import { action } from 'satcheljs';
/**
 * Action to propagate the pin items action to client stores
 * @param rowKeys - the row keys of the rows that get pinned/unpinned
 * @param tableViewId - the table view id
 * @param shouldMarkAsPinned - the pinned value to be set
 */
export default action('MARK_ITEMS_PINNED_STORE_UPDATE', function (rowKeys, tableViewId, shouldMarkAsPinned) {
    return {
        rowKeys: rowKeys,
        tableViewId: tableViewId,
        shouldMarkAsPinned: shouldMarkAsPinned,
    };
});
//# sourceMappingURL=markItemsAsPinnedStoreUpdate.js.map